import { FC, ReactNode } from "react";

interface WidgetTooltipProps {
  title: ReactNode;
  subtitle: ReactNode;
  content: ReactNode;
}

export const WidgetTooltip: FC<WidgetTooltipProps> = ({
  title,
  subtitle,
  content,
}) => (
  <div className="font-secondary box-border w-[160px] min-w-0 break-words rounded-xl bg-white p-3 shadow-[0_5px_16px_0_rgba(0,0,0,0.16)]">
    <div className="flex min-w-0 flex-col gap-0.5">
      <div className="text-dark-800 min-w-0 text-[15px] font-medium">
        {title}
      </div>
      <div className="text-grey-900 min-w-0 text-[13px] leading-[140%]">
        {subtitle}
      </div>
    </div>
    <div className="bg-dark-100 my-2 h-px w-full" />
    <div className="min-w-0 break-words">{content}</div>
  </div>
);
